module.exports = __webpack_public_path__ + "img/187.2d957a7b.jpg";